export default __webpack_public_path__ + "static/media/cloud-data.569a470e.png";